// test1077
(1077 && 0);
